import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ShipmentChargesTable from "../../components/ShipmentCharges/ShipmentChargesTable";



const ShipmentChargesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Shipment Charges" />
                <ShipmentChargesTable/>



            </MasterLayout>
        </>
    );
};

export default ShipmentChargesPage;
